import { HubConnectionBuilder, HttpTransportType, HubConnection } from '@microsoft/signalr';

export function createSignalRHubConnexion(urlHub: string): HubConnection
{
    return new HubConnectionBuilder()
        .withUrl(urlHub, {
            transport: HttpTransportType.WebSockets,
            skipNegotiation: true
        })
        .withAutomaticReconnect()
        .build();
}
